import { AxiosResponse } from 'axios';
import { IGetAutomationTemplateByIdResponse } from 'models/http/automation-templates';
import { IGetAutomationsTemplatesResponse } from 'models/http/automations';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { serverAxios } from 'utils/http';

class AutomationTemplateHttp {
  private static route = '/automations/templates';

  public async get(): Promise<IGetAutomationsTemplatesResponse[]> {
    return serverAxios.get(`${AutomationTemplateHttp.route}`).then((response: AxiosResponse<IGetAutomationsTemplatesResponse[]>) => {
      return response.data;
    });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetAutomationTemplateByIdResponse> {
    return serverAxios
      .get(`${AutomationTemplateHttp.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetAutomationTemplateByIdResponse>) => {
        return response.data;
      });
  }
}

export default AutomationTemplateHttp;
